<template>
  <div class="wallet">
    <ProgressHUD
        ref="progress"
        :display="true"
    />

    <layout-main>
      <div class="row">
          <div class="col-lg-12">
              <h4 class="page-header">Wallets Explorer</h4>
          </div>
      </div>
      <div class="row top-row">
          <div class="col-lg-12 col-md-12 col-xs-12">
              <div class="panel panel-green green-wallet">
                  <div class="panel-content wallet-top">
                    <div :class="profileData.user.typeOfProfile!='investor'?'col-lg-3 col-md-6':'col-lg-3 col-md-3'" class="col-xs-12">
                        <img src="static/dist/images/Greeneum Symbol Logo.png">
                        <span>{{green}}</span>
                        <p>GREEN(erc20) <i class="fa fa-info-circle" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="erc20 Etherum Blockchain (ETH)"></i></p>
                        <!-- <router-link class="btn-green" to="/contribute">Get GREEN</router-link> -->
                    </div>
                    <div :class="profileData.user.typeOfProfile!='investor'?'col-lg-3 col-md-6':'col-lg-3 col-md-3'" class="col-xs-12">
                        <img src="static/dist/images/Greeneum Symbol Logo.png">
                        <span>{{bep20}}</span>
                        <p>GREEN(bep20) <i class="fa fa-info-circle" aria-hidden="true" data-toggle="tooltip" data-placement="bottom" title="bep20 Binance Smart Chain (BSC)"></i></p>
                        <!-- <router-link class="btn-green" to="/contribute">Get GREEN</router-link> -->
                    </div>
                    <div :class="profileData.user.typeOfProfile!='investor'?'col-lg-3 col-md-6':'col-lg-3 col-md-3'" class="col-xs-12" v-if="profileData.user.typeOfProfile=='investor'">
                        <img src="static/dist/images/Greeneum Symbol Logo.png">
                        <span>0</span>
                        <p>GREEN Bonds</p>
                    </div>
                    <div :class="profileData.user.typeOfProfile!='investor'?'col-lg-3 col-md-6':'col-lg-3 col-md-3'" class="col-xs-12" >
                        <img src="static/dist/images/Greeneum-Green-Certificates.png">
                        <span>{{ sumGGC }}</span>
                        <p>GREEN Certificates</p>
                    </div>
                    <div :class="profileData.user.typeOfProfile!='investor'?'col-lg-3 col-md-6':'col-lg-3 col-md-3'" class="col-xs-12">
                        <img src="static/dist/images/Greeneum-Carbon-Credits.png">
                        <span>{{ sumGCC }}</span>
                        <p>Carbon Credits</p>
                    </div>
                  </div>
              </div>
          </div>
          <div class="col-lg-12 col-md-12 col-xs-12">
              <div class="panel panel-green green-wallet">
                  <div class="panel-heading top-panel-heading">Payment Wallets</div>
                  <div class="panel-content">
                      <ul>
                          <li>
                              <img src="static/dist/images/coinbasebtc.png">
                              <!-- <p>Bitcoin</p> -->
                              <span class="coin"><input class="form-control" type="text" placeholder="Bitcoin Wallet" name="walletAddress" :disabled="profileData.user.walletAddress!='' && !isEdit" v-model="profileData.user.walletAddress" @focus="isEdit=true;">                
                              <a v-on:click="save()" v-if="isBtnEdit">Save</a>
                              <a v-on:click="isEdit==true" v-else>Edit</a></span>
                              <!-- <span>{{coinbtc}}</span>   -->
                              <!-- <a class="btn-green grey" disabled v-if="profileData.user.walletAddress==''">Get GREEN</a>
                              <a class="btn-green" v-else @click="getGreen('BTC')">Get GREEN</a>    -->                         
                             <!--  <p>USD</p> -->
                          </li>
                          <li>
                              <img src="static/dist/images/coinbaseeth.png">                              
                              <!-- <p>Ethereum</p> -->
                              <span class="coin"><input class="form-control" type="text" placeholder="Etherum Wallet" name="walletAddressETH" :disabled="profileData.user.walletAddressETH!='' && !isEditETH" v-model="profileData.user.walletAddressETH" @focus="isEditETH=true;">                
                              <a v-on:click="save()" v-if="isBtnEditETH">Save</a>
                              <a v-on:click="isEditETH=true;isBtnEditETH=true;" v-else>Edit</a></span>
                              <!-- <span>{{coineth}}</span> -->
                              <!-- <a class="btn-green grey" disabled v-if="profileData.user.walletAddressETH==''">Get GREEN</a> -->
                              <!-- <a class="btn-green" v-else @click="getGreen('ETH')">Get GREEN</a> -->
                              <!-- <p>USD</p> -->
                          </li>
                          <li>
                              <img src="static/dist/images/coinbaseeth.png">                              
                              <!-- <p>Tether</p> -->
                              <span class="coin"><input class="form-control" type="text" placeholder="Etherum Wallet" name="walletAddressUSDT" :disabled="profileData.user.walletAddressUSDT!='' && !isEditUSDT" v-model="profileData.user.walletAddressUSDT" @focus="isEditUSDT=true;">                
                              <a v-on:click="save()" v-if="isBtnEditUSDT">Save</a>
                              <a v-on:click="isEditUSDT=true;isBtnEditUSDT=true;" v-else>Edit</a></span>
                              <!-- <span>{{coineth}}</span> -->
                              <!-- <a class="btn-green grey" disabled v-if="profileData.user.walletAddressUSDT==''">Get GREEN</a>
                              <a class="btn-green" v-else @click="getGreen('USDT')">Get GREEN</a> -->
                              <!-- <p>USDT</p> -->
                          </li>
                          <!-- <li>
                              <img src="static/dist/images/coinbaseeos.png">
                              
                              <span class="coin"><input class="form-control" type="text" placeholder="EOS Wallet" name="walletAddressEOS" :disabled="profileData.user.walletAddressEOS!='' && !isEditEOS" v-model="profileData.user.walletAddressEOS" @focus="isEditEOS=true;">                
                              <a v-on:click="save()" v-if="isBtnEditEOS">Save</a>
                              <a v-on:click="isEditEOS=true;isBtnEditEOS=true;" v-else>Edit</a></span>
                              <a class="btn-green grey" disabled v-if="profileData.user.walletAddressEOS==''">Get GREEN</a>
                              <a class="btn-green" v-else @click="getGreen('EOS')">Get GREEN</a>
                          </li> -->
                      </ul>
                      <div id="kredeum-opensky" chainid="56" address="0x0Ad1aEFC15b29DE1107226Ca1d00b7bb97622b48"></div>
                      <div id="kredeum-opensky" chainid="56" address="0x0Ad1aEFC15b29DE1107226Ca1d00b7bb97622b48" tokenid="1"></div>
                  </div>
              </div>
          </div>
      </div>

      <div class="row top-row row-line">
          <div class="col-lg-8 col-md-8 col-xs-12">
              <div class="panel panel-green">
                  <div class="panel-heading top-panel-heading">TRANSACTIONS</div>                 
                     <ul class="nav nav-tabs">
                      <li role="presentation" @click="currentTab = 'eth'"><a href="#"><b>ETH</b></a></li>
                      <li role="presentation" @click="currentTab = 'btc'"><a href="#"><b>BTC</b></a></li>
                      <!-- <li role="presentation" @click="currentTab = 'eos'"><a href="#"><b>EOS</b></a></li> -->
                      <li role="presentation" @click="currentTab = 'green'"><a href="#"><b>GREEN(erc20)</b></a></li>
                      <li role="presentation" @click="currentTab = 'bep20'; getBep20();"><a href="#"><b>GREEN(bep20)</b></a></li>
                   </ul>
                   <div class="tab-content">
                      <div v-if="currentTab == 'eth'">
                        <div v-if="list.length > 0">
                          <p v-for="(t, index) in list" v-bind:key="index"><a :href="'https://etherscan.io/tx/'+t.hash" target='_blank'>
                            <span class="first" :title="t.hash">{{t.hash }}</span>
                            <span class="number"> {{ t.value }}</span>
                            <span class="date"> {{ (new Date(t.timeStamp*1000)) }}</span>
                            <span class="last" :title="'from: '+t.from"> {{t.from}}</span>
                            <span class="end" :title="'to: '+t.to"> {{t.to}}</span>
                          </a></p>
                          <p><a :href="'https://etherscan.io/txs?a='+profileData.user.walletAddressETH" target='_blank'>All Transactions</a></p>
                        </div>
                        <div v-else>Add ETH wallet address</div>
                      </div>

                      <div v-if="currentTab == 'btc'">
                        <div v-if="txsbtc.length > 0">
                          <p v-for="(tb, index) in txsbtc" v-bind:key="index"><a :href="'https://www.blockchain.com/btc/tx/'+tb" target='_blank'>                          
                            <span class="first" :title="tb.hash">{{tb.hash }}</span>
                            <span class="number"> {{ tb.result }}</span>
                            <span class="date"> {{ (new Date(tb.time*1000)) }}</span>
                            <span class="last" :title="'from: '+tb.inputs[0].prev_out.addr"> {{tb.inputs[0].prev_out.addr}}</span>
                            <span class="end" :title="'to: '+tb.out[0].addr"> {{tb.out[0].addr}}</span>
                          </a></p>
                          <p><a :href="'https://www.blockchain.com/btc/address/'+profileData.user.walletAddress" target='_blank'>All Transactions</a></p>
                        </div>
                        <div v-else>Add BTC wallet address</div>
                      </div>

                      <!-- <div v-if="currentTab == 'eos'">
                        <div v-if="profileData.user.walletAddressEOS">
                        </div>
                        <div v-else>Add EOS wallet address</div>  
                      </div> -->

                      <div v-if="currentTab == 'green'">
                        <p v-for="(tg, index) in txsgreen" v-bind:key="index"><a :href="'https://etherscan.io/tx/'+tg" target='_blank'>
                            <span class="first" :title="tg.hash">{{tg.hash }}</span>
                            <span class="number"> {{ tg.value }}</span>
                            <span class="date"> {{ (new Date(tg.timeStamp*1000)) }}</span>
                            <span class="last" :title="'from: '+tg.from"> {{tg.from}}</span>
                            <span class="end" :title="'to: '+tg.to"> {{tg.to}}</span>
                        </a></p>
                        <p v-show="profileData.user.walletAddressGREEN !==''"><a :href="'https://etherscan.io/address/'+profileData.user.walletAddressGREEN + '#tokentxns'" target='_blank'>All Transactions</a></p>
                      </div>

                      <div v-if="currentTab == 'bep20'">
                        <div v-if="txsbep20.length > 0">
                          <p v-for="(tg20, index) in txsbep20" v-bind:key="index">
                            <a :href="'https://bscscan.com/tx/'+tg20" target='_blank'>
                              <span class="first" :title="tg20.hash">{{tg20.hash }}</span>
                              <span class="number" :title="'value: '+tg20.value"> {{ tg20.value }}</span>
                              <span class="date"> {{ (new Date(tg20.timeStamp*1000)) }}</span>
                              <span class="last" :title="'from: '+tg20.from"> {{tg20.from}}</span>
                              <span class="end" :title="'to: '+tg20.to"> {{tg20.to}}</span>
                            </a>
                          </p>
                          <p v-show="profileData.user.walletGREENBEP20 !==''"><a :href="'https://bscscan.com/address/'+profileData.user.walletGREENBEP20 + ''" target='_blank'>All Transactions</a></p>
                        </div>
                        <div v-else>Add GREEN(bep20) wallet address</div>
                      </div>
                   </div>
                 <!--  <div class="panel-content p-block projects">
                    <div v-if="txs.length > 0 || txsbtc.length > 0" class="wallet">
                      <div v-if="txs.length > 0">
                        <p><b>Etherum</b></p>
                        <p v-for="(t, index) in txs" v-bind:key="index"><a :href="'https://etherscan.io/tx/'+t" target='_blank'>{{t}}</a></p>
                        <p><a :href="'https://etherscan.io/txs?a='+profileData.user.walletAddressETH" target='_blank'>All Transactions</a></p>
                      </div>
                      <div v-if="txsbtc.length > 0">
                        <p><b>Bitcoin</b></p>
                        <p v-for="(tb, index) in txsbtc" v-bind:key="index"><a :href="'https://www.blockchain.com/btc/tx/'+tb" target='_blank'>{{tb}}</a></p>
                        <p><a :href="'https://www.blockchain.com/btc/address/'+profileData.user.walletAddress" target='_blank'>All Transactions</a></p>
                      </div>
                    </div>
                    <div v-else class="no-project">
                      <p>No data yet</p>
                      <br>
                      <p>As soon as our Trade is open, you will see here your tokens transactions.</p>
                    </div>
                    
                  </div> -->
              </div>
          </div>
          <div class="col-lg-4 col-md-4 col-xs-12">
              <div class="panel panel-green">
                  <div class="panel-heading top-panel-heading">Market Value</div>
                  <div class="panel-content p-block projects">
                    <!-- <div class="no-project" v-if="profileData.user.typeOfProfile!='investor'">
                      <p>No data yet</p>
                      <br>
                      <p>As soon as our Trade is open, you can follow here the market value of the GREEN tokens month by month.</p>
                      <!-- <router-link class="btn-green" to="/contribute">Get GREEN</router-link> -->
                    <!-- </div> --> 
                    <!-- <div class="no-project investor" v-else> -->
                    <div class="no-project investor">
                       <ul>
                          <li>
                              <img src="static/dist/images/coinbasebtc.png">
                              <span class="coinmarket">{{coinbtc}}</span>                                
                              <p>USD</p>
                          </li>
                          <li>
                              <img src="static/dist/images/coinbaseeth.png">
                              <span class="coinmarket">{{coineth}}</span>                              
                              <p>USD</p>
                          </li>
                          <!-- <li>
                              <img src="static/dist/images/coinbaseeos.png">
                              <span class="coinmarket">{{coineos}}</span>                              
                              <p>USD</p>
                          </li> -->
                      </ul>
                    </div>
                  </div>
              </div>
              <!-- <div class="col-lg-12 col-md-12 col-xs-12 btn-line ta-center">
                
                <input class="form-control" v-if="saveW==1" type="text" placeholder="Etherum Wallet" name="wallet" v-model="wallet" >
                <a v-if="saveW==0" v-on:click="saveW=1">Add Wallet</a>
                <a v-else v-on:click="save()">Save Wallet</a>

              </div>  -->             
              <a href="https://edge.app/" class="ed-link" target="_blank"></a>
              <a href="https://www.ledger.com/" class="mm-link"  target="_blank"></a>
              <a href="https://trezor.io/" class="tz-link"  target="_blank"></a>
              <!-- <a href="https://metamask.io/" class="mm-link"  target="_blank"></a> -->
          </div>
      </div>

      <div class="row modal" role="dialog"> 
        <div class="modal-dialog" role="document">
          <div class="col-lg-12 modal-content">
              <h4 class="page-header">GET GREEN</h4>
               <div class="modal-body">
                                   <div class="to-wallet">
                                      <b>To Wallet: </b> {{ toWallet }}
                                    </div>
                                    <div>
                                        <input
                                            type="text"
                                            name="Amount"
                                            v-validate="'required'"
                                            class="form-control"
                                            v-model="amount"
                                            placeholder="Amount"
                                            :class="{'error-input': errors.has('Amount')}"
                                        >
                                        <span
                                            class="error"
                                            v-if="errors.has('Amount')"
                                        >{{errors.first('Amount')}}</span>
                                    </div>    
                                    <div class="form-group info">
                                          <label class="control-label font-style-italic">Please DO NOT send crypto from any online exchanges. We will not be able to identify the transaction when sending from online exchanges.</label>
                                          <!-- <label class="control-label font-style-italic">Minimal investment: 0.05 BTC, 0.5 ETH, 1000EOS.</label> -->
                                          <label class="control-label font-style-italic">Minimal investment: 0.05 BTC, 0.5 ETH, 1 USDT.</label>
                                    </div>
                                      
                                    <button @click="saveGREEN()" class="go">Get GREEN</button>
                                    </div>
          </div>
        </div>  
      </div>
    </layout-main>
  </div>
</template>
<style type="text/css">
  .panel.panel-green.green-wallet ul li {
    /*border-bottom: 1px dashed #b7b7b7;*/
    width: 100%;
  }
  .panel.panel-green.green-wallet ul li p:first-child {min-width: 130px;}
  .wallet .panel.panel-green.green-wallet ul li p {
      display: inline-block;
      width: auto;
      float: left;
  }
  .panel.panel-green.green-wallet ul li span {
      display: inline-block;
      float: left;
      /*font-size: 16px;*/
  }
  .panel-green.green-wallet .panel-content {
      padding-left: 1%;
  }
  .wallet-top .btn-green {
      margin: 0 15px;
  } 
  .no-project { margin-bottom: 30px; }
  .no-project.investor { padding: 0 30px; }
  .coinmarket { width: 100%; }
  .to-wallet { margin: 10px 20px 20px; text-align: center; }
  .form-group.info { margin-left: 30px; }
  .font-style-italic { font-size: 12px; font-weight: normal; }
  .btn-green.grey { background: grey; }
</style>
<script defer src="https://app.kredeum.com/assets/kredeum-nfts.js"></script>
<script>
import LayoutMain from './../../layouts/LayoutMain.vue';
import ProgressHUD from './../ProgressHUD/index.vue'
import Footer from './../Footers/Footer/index.vue'
import LineChart from './../../data/LineChart.js'
import { Api, Toast } from './../../services'

export default {
  name: 'Wallet',
  props: [],
  components: {
    LayoutMain,
    ProgressHUD,
    Footer,
    LineChart,
  },
  data() {
    return {
      profileData: null,
      sumTokens: 0,
      productUnAnswComments: {},
      totalProductUnAnswComments: 0,
      serviceUnAnswComments: {},
      totalServiceUnAnswComments: 0,
      lat: 51.508530,
      lng: -0.076132,
      validResponse: "",
      city: "London",
      location: "United Kingdom",
      hours: 0,
      mins: 0,
      day: "",
      temp: true,
      tempC: "",
      tempF: "",
      conditionText: "",
      conditionIcon: "https:",
      humidity: "",
      precip: "",
      wind: 0,
      windmph: 0,
      activeId: 0,
      datacollection: {},
      heightChart: 0,
      sumGreenCertificates: 0,
      sumBonusCarbon: 0,
      itemsCarousel: 3.25,
      green: 0,
      bep20: 0,
      txs: [],
      txsbtc: [],
      txseos: [],
      txsgreen: [],
      txsbep20: [],
      wallet: '',
      coinbtc: 0,
      coineth: 0,
      coineos: 0,
      saveW: 0,
      isEdit: false,
      isBtnEdit: false,
      isEditEOS: false,
      isBtnEditEOS: false,
      isEditUSDT: false,
      isBtnEditUSDT: false,
      isEditETH: false,
      isBtnEditETH: false,
      currentTab: 'eth',
      apiKey: 'RPS3VM5G9V7FBYRGVI913DV8G5Z3Y43Z27',
      walletName: '',
      amount: '',
      walletAddress: '',
      toWallet: '',
      list: [],
      listBTC: [],
      listEOS: [],
      listGREEN: [],  
      sumGGC: 0,
      sumGCC: 0,    
    }
  },
  methods: {    
    
    refreshSize(event) {
      var ctx = document.getElementById("line-chart");
      // console.log(ctx)
      // ctx.canvas.width = 200;
      if (ctx != null && ctx != "null") ctx.height = 200;
     
    },

    getGreen (w) {
      this.walletName = w;
      $('.modal').modal('show');
      this.toWallet = (w == "BTC") ? "3L2QFskrhzHshkbpuhnHVpCGAz7JoQraHk" : "0x26139abf60a81c1a962e5563a510324c4756ed37"
      // this.toWallet = (w == "EOS") ? "" : (w == "BTC") ? "3L2QFskrhzHshkbpuhnHVpCGAz7JoQraHk" : "0x26139abf60a81c1a962e5563a510324c4756ed37"
    },

    async saveGREEN (){
      console.log("saveGREEN ****************************")
      console.log(this.walletName)
       try {
        // if (this.profileData.user.walletAddressETH == '' && this.profileData.user.walletAddressETH == '' && this.profileData.user.walletAddressEOS == '') return;

        this.$refs.progress.show()

       
        var formData = new FormData()
        formData.append('coin', this.walletName)
        formData.append('walletAddress', this.walletAddress)
        formData.append('amount', this.amount)
        
        //var response = await Api.saveGREEN(formData) 

        // console.log("res --------------------")  
        // console.log(this.profileData.user)  

        $('.modal').modal('hide')
        $('.modal-backdrop.in').remove()    

        if (this.profileData.user.fullName === '' || this.profileData.user.country === '' || this.profileData.user.address === '' || this.profileData.user.idPassportForKYC == undefined || this.profileData.user.idPassportForKYC.length <= 0) {

          var c = '', addr = '', p = '', b = ''
          c = this.profileData.user.country ? this.profileData.user.country : ''
          addr = this.profileData.user.address ? this.profileData.user.address : ''
          p = this.profileData.user.idPassportForKYC ? this.profileData.user.idPassportForKYC[0] : ''
          b = this.profileData.user.utilityBill ? this.profileData.user.utilityBill : ''

          this.$localStorage.set('address', addr)
          this.$localStorage.set('country', c)
          this.$localStorage.set('idPassportForKYC', p)
          this.$localStorage.set('utilityBill', b)

          this.$router.push('/kyc')

        } else {
   
           Toast.success({
            toast: this.$toast,
            title: 'Success!',
            message: 'GREEN Successfully Saved',
          })
        }   

      } catch (error) {
          console.log("error>>>>>>>>>>>>>>>>>>>>>>")
          console.log(error)
          this.validationMessage = 'Something went wrong.'

          Toast.error({
            toast: this.$toast,
            title: 'Error saveGREEN',
            message: 'Something went wrong.',
          })
      } finally {
          this.$refs.progress.hide()
      }    
  
    },

    async save() {
      try {
        if (this.profileData.user.walletAddressETH == '' && this.profileData.user.walletAddressETH == '' && this.profileData.user.walletAddressUSDT == '') return;

        this.$refs.progress.show()

        var formData = new FormData()
        formData.append('walletAddress', this.profileData.user.walletAddress)
        formData.append('walletAddressETH', this.profileData.user.walletAddressETH)
        formData.append('walletAddressUSDT', this.profileData.user.walletAddressUSDT)
        
        this.isEdit = false;
        this.isEditETH = false;
        this.isEditUSDT = false;

        if (this.profileData.user.walletAddress != "") this.isBtnEdit = false
        if (this.profileData.user.walletAddressETH != "") this.isBtnEditETH = false
        if (this.profileData.user.walletAddressUSDT != "") this.isBtnEditUSDT = false

        var response = await Api.addWallet(formData)
        // this.saveW = 0

         Toast.success({
          toast: this.$toast,
          title: 'Success!',
          message: 'Wallet Address Successfully Saved',
        })

      } catch (error) {
          this.validationMessage = 'Something went wrong.'

          Toast.error({
            toast: this.$toast,
            title: 'Error',
            message: 'Something went wrong.',
          })
      } finally {
          this.$refs.progress.hide()
      }    
    },
    async getBep20(){
      if(this.profileData.user.walletGREENBEP20){          
          var resbep20 = await Api.getBep20(this.profileData.user.walletGREENBEP20)
          this.txsbep20 = resbep20.data.results              
        }
      return this.txsbep20;  
    },
  },

  async created() {
    
    $('.p-block').tooltip({
        selector: "[data-toggle=tooltip]",
        container: "body"
    })

    try {
      var _s = this    

      var response = await Api.myProfile()      
      if (response.data) {
        this.profileData = response.data.results

        this.profileData.user.walletAddress = (this.profileData.user.walletAddress==null)?'':this.profileData.user.walletAddress  
        this.profileData.user.walletAddressETH = (this.profileData.user.walletAddressETH==null)?'':this.profileData.user.walletAddressETH
        this.profileData.user.walletAddressEOS = (this.profileData.user.walletAddressEOS==null)?'':this.profileData.user.walletAddressEOS
        if (this.profileData.user.walletAddress == "") this.isBtnEdit = true
        if (this.profileData.user.walletAddressETH == "") this.isBtnEditETH = true
        if (this.profileData.user.walletAddressEOS == "") this.isBtnEditEOS = true 
       

        var sumTokens = 0, sumGreenCertificates = 0, sumBonusCarbon =0, pExist = this.profileData.projectsExist;
        if(this.profileData.balanceETH)
          this.green = this.profileData.balanceETH[1].toFixed(2)
        if(this.profileData.balanceGREENBEP20)
          this.bep20 = this.profileData.balanceGREENBEP20.toFixed(4)

        var ownerAmountGGC = (this.profileData.user.ownerAmountCertificates) ? this.profileData.user.ownerAmountCertificates : 0, sum1 = (this.profileData.sumGGC) ? (this.profileData.sumGGC).toFixed(2) : 0
        this.sumGGC = parseFloat(sum1) + ownerAmountGGC
        var ownerAmountGCC = (this.profileData.user.ownerAmountCarbonCredits) ? this.profileData.user.ownerAmountCarbonCredits : 0, sum2 = (this.profileData.sumGCC) ? (this.profileData.sumGCC).toFixed(2) : 0
        this.sumGCC = parseFloat(sum2) + ownerAmountGCC

        
        var res = await axios.get("https://api.etherscan.io/api?module=account&action=txlist&address="+this.profileData.user.walletAddressETH+"&sort=desc") //0x77e5cba57201272a1f85c3d718c6c4ae83564f68
        var list = res.data.result; 
        this.list = list.slice(0,10)
        
        // if(list && list.length > 0 && typeof(list) != 'string'){
        //   var listSize = (list.length > 10) ? 10 : list.length
        //   for (var i=0; i<listSize; i++) {
        //     // console.log(list[i])
        //     if(list[i]) {
        //       // console.log(list[i])
        //       this.txs.push(list[i].hash)
        //     }  
        //   }
        // }  

        if (this.profileData.user.walletAddress && this.profileData.user.walletAddress.length > 31) {  
          var resbtc = await axios.get("https://blockchain.info/rawaddr/"+this.profileData.user.walletAddress+"?cors=true") 
          var listbtc = resbtc.data             
          // console.log("****************************************************************** 1")
          // console.log(listbtc)
          if(listbtc && listbtc.txs && listbtc.txs.length > 0){
              var listSize = (listbtc.txs.length > 10) ? 10 : listbtc.txs.length
              for (var i=0; i<listSize; i++)             
                if(listbtc.txs[i] != undefined && listbtc.txs[i].hash) 
                  this.txsbtc.push(listbtc.txs[i]) 
          }  
        } 

        if (this.profileData.user.walletAddressGREEN) {  
          var resgreen = await axios.get("https://api.etherscan.io/api?module=account&action=tokentx&address="+this.profileData.user.walletAddressGREEN+"&startblock=0&endblock=999999999&sort=desc&apikey=" + this.apiKey) //
          // var resgreen = await axios.get("https://etherscan.io/address/"+this.profileData.user.walletAddressGREEN+"#tokentxns") // 0x08c3d1a2a0E01505DE0DE2dDa22e15970e9B5C6D
          var listgreen = resgreen.data.result;
          // console.log("******************************* listgreen *********************************** ")
          // console.log(listgreen)
          // this.txsgreen = listgreen
          if(listgreen && listgreen.length > 0)
            for (var i=0; i<10; i++) 
              if(listgreen[i] != undefined && listgreen[i].hash)
                this.txsgreen.push(listgreen[i])                
        }    


        var coinbtc = await axios.get("https://api.coinbase.com/v2/prices/BTC-USD/buy",  { headers: { "Authorization": "Bearer abd90df5f27a7b170cd775abf89d632b350b7c1c9d53e08b340cd9832ce52c2c"} })
        this.coinbtc = coinbtc.data.data.amount;

        var coineth = await axios.get("https://api.coinbase.com/v2/prices/ETH-USD/buy",  { headers: { "Authorization": "Bearer abd90df5f27a7b170cd775abf89d632b350b7c1c9d53e08b340cd9832ce52c2c"} })
        this.coineth = coineth.data.data.amount;

        var coineos = await axios.get("https://api.coinbase.com/v2/prices/EOS-USD/buy",  { headers: { "Authorization": "Bearer abd90df5f27a7b170cd775abf89d632b350b7c1c9d53e08b340cd9832ce52c2c"} })
        this.coineos = coineos.data.data.amount;

        await new Promise(resolve => this.$nextTick(resolve));      
       
      } else {
        this.validationMessage = 'Something went wrong.'

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'Something went wrong.',
        })
      }

    } catch (error) {
      console.error(error)
      this.validationMessage = error.message

      Toast.error({
        toast: this.$toast,
        title: 'Error',
        message: error.message,
      })
    } finally {
      this.$refs.progress.hide()
    }
  },
   mounted() {
    window.addEventListener('resize', this.refreshSize)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Account/Wallet.vue